import { useValidationRules } from "@/iti-core-react/hooks/validation-rule-required-editors";
import TextBox, { Button } from "devextreme-react/text-box";
import DxValidator from "devextreme-react/validator";
import {
	EnterKeyEvent,
	InitializedEvent,
	ValueChangedEvent,
} from "devextreme/ui/text_box_types";
import { InitializedEvent as InitializedValidatorEvent } from "devextreme/ui/validator_types";
import { useState } from "react";
import { ItiString } from "../../utils/iti-string";
import "./ItiPasswordBox.scss";

interface ItiPasswordBoxProps {
	name?: string;
	label?: string;
	labelClass?: string;
	width?: number | string;
	mode?: "text" | "email" | "password" | "search" | "tel" | "url";
	tabIndex?: number;
	stylingMode?: "outlined" | "underlined" | "filled";
	placeholder?: string;
	showClearButton?: boolean;
	readOnly?: boolean;
	disabled?: boolean;
	visible?: boolean;
	value?: string;
	validationRules?: any;
	className?: string;
	elementAttr?: any;
	validationMessageMode?: "always" | "auto";
	children?: any;
	inputAttr?: any;
	onValueChanged?: (e: ValueChangedEvent) => void;
	saveTextBoxInstance?: (e: InitializedEvent) => void;
	onInitializedValidator?: (e: InitializedValidatorEvent) => void;
	onEnterKey?: (e: EnterKeyEvent) => void;
}

export default function ItiPasswordBoxComponent({
	name,
	label,
	labelClass = "dx-field-item-label-text",
	elementAttr = { class: "field-lg" },
	width,
	tabIndex,
	stylingMode = "outlined",
	placeholder,
	showClearButton = true,
	readOnly = false,
	disabled = false,
	visible = true,
	value,
	validationRules,
	className,
	children,
	inputAttr = { autocomplete: "new-password" },
	validationMessageMode = "always",
	onValueChanged,
	saveTextBoxInstance,
	onInitializedValidator,
	onEnterKey,
}: Readonly<ItiPasswordBoxProps>) {
	const [openEyeVisible, setOpenEyeVisible] = useState(true);
	const { isRequired } = useValidationRules(validationRules);

	const passwordButtonOpen = {
		icon: "mdi mdi-eye",
		elementAttr: { class: "password-button" },
		visible: !readOnly && !disabled,
		onClick: () => {
			setOpenEyeVisible(false);
		},
	};

	const passwordButtonClose = {
		icon: "mdi mdi-eye-off",
		visible: !readOnly && !disabled,
		elementAttr: { class: "password-button" },
		onClick: () => {
			setOpenEyeVisible(true);
		},
	};

	return (
		<>
			{label && !ItiString.isNullOrWhiteSpace(label) && (
				<div className={labelClass}>{label + (isRequired ? "*" : "")}</div>
			)}

			<TextBox
				name={name}
				className={className}
				elementAttr={elementAttr}
				width={width}
				mode={openEyeVisible ? "password" : "text"}
				tab-index={tabIndex}
				stylingMode={stylingMode}
				placeholder={placeholder}
				showClearButton={showClearButton}
				readOnly={readOnly}
				disabled={disabled}
				visible={visible}
				value={value}
				inputAttr={inputAttr}
				validationMessageMode={validationMessageMode}
				onValueChanged={(e: ValueChangedEvent) => {
					if (onValueChanged) {
						onValueChanged(e);
					}
				}}
				onInitialized={saveTextBoxInstance}
				onEnterKey={onEnterKey}
			>
				{openEyeVisible ? (
					<Button name="today" location="after" options={passwordButtonOpen} />
				) : (
					<Button name="today" location="after" options={passwordButtonClose} />
				)}

				<DxValidator
					validationRules={validationRules}
					onInitialized={onInitializedValidator}
				/>
				{children}
			</TextBox>
		</>
	);
}
